// extracted by mini-css-extract-plugin
export default {"Image":"Image_Image__4x8aG","Image__AnimatedStub":"Image_Image__AnimatedStub__Z5249","moveBackroundHorizontal":"Image_moveBackroundHorizontal__9-O2S","fadeIn":"Image_fadeIn__OKfiN"};